import { args } from "../../lib/args/args";
import { ACTIONS } from "@/commands/sessions/sessions-constants";
import { sessionActions } from "@/commands/sessions/session-actions";
import { runSessionOperation } from "@/commands/command/run-session-operation";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function sessionsCommand(parsed: ParsedArgs): Promise<void> {
  // The action is validated FIRST, so `hepha sessions frobnicate <id>` names
  // the real problem instead of asking for an argument it would never use.
  const action = args.action(parsed, "sessions", ACTIONS, "list");
  const asJson = parsed.booleans.has("json");

  const dedicated = sessionActions[action];
  if (dedicated) {
    return await dedicated(parsed, asJson);
  }
  await runSessionOperation(parsed, action, asJson);
}
